// ReadyTrades wordmark + monogram — editorial serif R with a small orange chip.
// Kept minimal on purpose: no icon-only, just typographic mark.

export const LogoMark = ({ size = 32, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    <rect x="1" y="1" width="38" height="38" rx="9" fill="#0B1C2E" />
    <text
      x="50%"
      y="55%"
      dominantBaseline="middle"
      textAnchor="middle"
      fontFamily="Bricolage Grotesque, Inter, sans-serif"
      fontWeight="600"
      fontSize="22"
      fill="#F5F1EA"
      style={{ letterSpacing: '-0.03em' }}
    >
      R
    </text>
    <circle cx="30" cy="11" r="3.5" fill="#EF5B25" />
  </svg>
);

export const LogoWordmark = ({ size = 32, tone = "ink" }) => (
  <span className="flex items-center gap-2.5 select-none">
    <LogoMark size={size} />
    <span
      className="font-display leading-none"
      style={{
        fontSize: size * 0.6,
        color: tone === "light" ? "#F5F1EA" : "#0B1C2E",
        letterSpacing: '-0.03em',
        fontWeight: 600,
      }}
    >
      ReadyTrades
    </span>
  </span>
);

// Backwards-compat alias removed — all callers now import LogoMark directly.
